module.exports = __webpack_public_path__ + "img/lunbo63.dacb2b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo63.png
// module id = 383N
// module chunks = 0